var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDanger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.90735e-06 6L5.29289 0.707105C5.68342 0.316581 6.31658 0.316581 6.70711 0.707105L12 6L-1.90735e-06 6Z",
    fill: "#FC818D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDanger);
export default __webpack_public_path__ + "static/media/arrow-danger.077f171f60341a653b77bd417ab70a1a.svg";
export { ForwardRef as ReactComponent };